import React from 'react'
import asyncComponent from '../../core/components/async-component/AsyncComponent'
import { Route } from 'react-router'
import StandaloneLogin from './components/StandaloneLogin'
import Oauth from './components/Oauth'
import ResetPassword from './components/ResetPassword'
// import FAQ from './components/FAQ'

const AsyncTermsOfService = asyncComponent({
  loader: () => import('./components/TermsOfService'),
  modules: ['./components/TermsOfService'],
  webpack: () => [require.resolveWeak('./components/TermsOfService')]
})
const AsyncCodeOfConduct = asyncComponent({
  loader: () => import('./components/CodeOfConduct'),
  modules: ['./components/CodeOfConduct'],
  webpack: () => [require.resolveWeak('./components/CodeOfConduct')]
})
const AsyncPrivacy = asyncComponent({
  loader: () => import('./components/PrivacyPolicy'),
  modules: ['./components/PrivacyPolicy'],
  webpack: () => [require.resolveWeak('./components/PrivacyPolicy')]
})

const miscRoutes =  [
  <Route exact key='term/default' path='/terms' component={AsyncTermsOfService} />,
  <Route exact key='conduct/default' path='/conduct' component={AsyncCodeOfConduct} />,
  <Route exact key='privacy/default' path='/privacy' component={AsyncPrivacy} />,
  <Route exact key='login/default' path='/login' component={StandaloneLogin} />,
  <Route key='oauth/default' path='/oauth-flask' component={Oauth} />,
  <Route exact key='resetpassword/default' path='/reset_password/:code/:email' render={({match, history})=>{
    const {code, email} = match.params
    //Prevent code leakage through document.referrer
    window.history.replaceState({},'Reset Password', '/reset_password')
    return <ResetPassword code={code} email={email} history={history} />
  }} />,
  // <Route exact key='faq/default' path='/faq' component={FAQ} />
]

export default miscRoutes



// WEBPACK FOOTER //
// ./src/domains/misc/index.js